<template>
  <div v-if="normalizedImages.length" class="seo-static-images" aria-hidden="true">
    <img
      v-for="image in normalizedImages"
      :key="image.src"
      :src="image.src"
      :alt="image.alt || ''"
      loading="lazy"
      decoding="async"
    />
  </div>
</template>

<script>
export default {
  name: 'SeoStaticImages',
  props: {
    images: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    normalizedImages() {
      const seen = new Set()

      return this.images
        .map((image) => (typeof image === 'string' ? { src: image, alt: '' } : image))
        .filter((image) => {
          const src = image && image.src
          if (!src || seen.has(src)) {
            return false
          }
          seen.add(src)
          return true
        })
    }
  }
}
</script>

<style scoped>
.seo-static-images {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  white-space: nowrap;
  pointer-events: none;
}

.seo-static-images img {
  width: 1px;
  height: 1px;
}
</style>
